import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Service-worker registration is handled by `components/SWUpdatePrompt.jsx`
// so it can wire the `updatefound` / `statechange` events and surface a
// "Update ready — tap to refresh" toast. Keeping the bootstrap in a React
// component also makes dev vs prod gating explicit and avoids a duplicate
// registration from this entry file.
